export function scrollIntoView(el: Element) {
  if (el.scrollIntoView) {
    el.scrollIntoView({ block: "start", behavior: "smooth" });
  } else {
    window.scrollTo(0, el.getBoundingClientRect().bottom);
  }
}


export const yearOrYears = (i:number) => i > 1 ? 'Jahre':'Jahr'
